import React from 'react';
import Badge from '../ui/Badge';
import type { MachineStatus } from '../../types/supply-gpu';

interface StatusBadgeProps {
  status: MachineStatus;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  const getStatusConfig = (status: MachineStatus) => {
    switch (status) {
      case 'connected':
        return {
          variant: 'success' as const,
          text: 'Successfully connected',
        };
      case 'pending':
        return {
          variant: 'primary' as const,
          text: 'Connection pending',
        };
      case 'benchmark_failed':
        return {
          variant: 'danger' as const,
          text: 'Benchmark not passed',
        };
      case 'not_connected':
        return {
          variant: 'secondary' as const,
          text: 'Not connected',
        };
      default:
        return {
          variant: 'default' as const,
          text: 'Unknown',
        };
    }
  };

  const { variant, text } = getStatusConfig(status);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={`Machine status: ${text}`}
    >
      <Badge
        variant={variant}
        size="sm"
        className={className}
      >
        {text}
      </Badge>
    </div>
  );
};

export default StatusBadge;